import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HeaderSection from '../comp/HeaderSection';
import ChartsSection from './ChartsSection';
import ChartsSection2 from './ChartsSection2';
import ChartsSection3 from './ChartsSection3';
import ModalDespesas from '../comp/ModalDespesas';
import ModalReceitas from '../comp/ModalReceitas';

import { getResumoFinanceiro, getResumoDespesas, getResumoContas, getDatasEmAberto } from '../../../api';

const PageContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* Adjust as needed for responsiveness */
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Receitas = () => {
  const [data, setData] = useState({});
  const [despesas, setDespesas] = useState({});
  const [contas, setContas] = useState({});
  const [datasEmAberto, setDatasEmAberto] = useState({});
  const [loading, setLoading] = useState(true);
  const [dateToOpen, setDateToOpen] = useState(null);
  const [dateToOpen2, setDateToOpen2] = useState(null);
  
  // Filtro ----
    const dataAtual = new Date();
    const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
    const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
    const emptyFiltro = {
      datainicial: primeiroDiaDoMes,
      datafinal: ultimoDiaDoMes,
    };
    const [filtro, setFiltro] = useState({ ...emptyFiltro});

  useEffect(() => {
    fetchData();
  }, [filtro]);

  const fetchData = async () => {
    try {
      const result = await getResumoFinanceiro();
      const result2 = await getResumoDespesas(filtro);
      const result3 = await getResumoContas();
      const result4 = await getDatasEmAberto(filtro);
      setData(result);
      setDespesas(result2);
      setContas(result3);
      setDatasEmAberto(result4);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  const onDoubleClick = (dateClicked) => {
    setDateToOpen(dateClicked);
  };

  const onDoubleClick2 = (dateClicked) => {
    setDateToOpen2(dateClicked);
  };

  const handleClose = async () => {
    setDateToOpen(null)
    setDateToOpen2(null)
    const result = await getDatasEmAberto();
     setDatasEmAberto(result);

  }

  if (loading) {
    return <p>Carregando gráfico...</p>;
  }

  return (
    <PageContainer>
      <HeaderSection title={'Início'} setFiltro={setFiltro} filtro={filtro}/>
      <ChartsSection data={data} />
      <ChartsSection2 data={despesas} receivableDates={datasEmAberto.aPagar} onDoubleClick={onDoubleClick} />
      <ChartsSection3 data={contas} receivableDates={datasEmAberto.aReceber} onDoubleClick={onDoubleClick2} />

      {dateToOpen && <ModalDespesas dateToOpen={dateToOpen} onClose={handleClose}/>}
      {dateToOpen2 && <ModalReceitas dateToOpen={dateToOpen2} onClose={handleClose}/>}
    </PageContainer>
  );
};

export default Receitas;
